module.exports = __webpack_public_path__ + "static/klaudia-451162fe4fa5bdcf8aeb6da18c0953fa.png";